/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { useEffect, useState } from 'react';
import { Asset } from '@wit/vtv-x-foundation-lib';
import ParentalControl from '../core/services/core/ParentalControl';

export default function useIsAdultContent(asset: Asset | undefined) {
  const [isAdultContent, setIsAdultContent] = useState<boolean | undefined>();

  useEffect(() => {
    setIsAdultContent(asset ? ParentalControl.UI.isAdult(asset) : undefined);
  }, [asset]);

  return isAdultContent;
}
